export const styles = {
  label: 'text-text-50 callout-normal',
  value: '!text-text-100 body-paragraphs-normal',
};
